<template>
  <div class="content">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="view-body">
      <el-card class="view-left-card" v-loading="isLoading">
        <div slot="header" class="view-left-card-title">
          <span>添加控件</span>
        </div>
        <el-scrollbar>
          <div class="view-left-card-item">
            <span class="view-left-card-item-span">选择题</span>
            <draggable
              v-model="addQuestionsListXZT"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListXZT"
                  :key="item.id"
                  @click="addClick(item)"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon110.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon111.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn0.svg"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
            <draggable
              v-model="addQuestionsListDXT"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListDXT"
                  :key="item.id"
                  @click="addClick(item)"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon120.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon121.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn1.svg"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div class="view-left-card-item">
            <span class="view-left-card-item-span">主观题</span>
            <draggable
              v-model="addQuestionsListWDT"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListWDT"
                  @click="addClick(item)"
                  :key="item.id"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon210.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon211.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn3.svg"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
            <draggable
              v-model="addQuestionsListHXTKT"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListHXTKT"
                  @click="addClick(item)"
                  :key="item.id"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon220.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon221.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn4.svg"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div class="view-left-card-item">
            <span class="view-left-card-item-span">预置题</span>
            <draggable
              v-model="addQuestionsListYZTXM"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListYZTXM"
                  @click="addClick(item)"
                  :key="item.id"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon460.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon461.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn46.png"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
            <draggable
              v-model="addQuestionsListYZTXB"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListYZTXB"
                  @click="addClick(item)"
                  :key="item.id"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon470.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon471.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn47.png"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
            <draggable
              v-model="addQuestionsListYZTNL"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListYZTNL"
                  @click="addClick(item)"
                  :key="item.id"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon480.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon481.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn48.png"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
            <draggable
              v-model="addQuestionsListYZTSJH"
              animation="300"
              chosenClass="chosenClass"
              :options="leftDrager"
              @start="addMoveStart"
              @end="addMoveEnd"
            >
              <transition-group>
                <div
                  class="view-left-card-item-dx"
                  v-for="item in addQuestionsListYZTSJH"
                  @click="addClick(item)"
                  :key="item.id"
                >
                  <div class="view-left-card-item-dx-content">
                    <img
                      class="colourless"
                      src="@/assets/answerExam/add_btn_icon490.svg"
                      alt=""
                    />
                    <img
                      class="color"
                      src="@/assets/answerExam/add_btn_icon491.svg"
                      alt=""
                    />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div>
                      <img
                        class="color"
                        src="@/assets/answerExam/hover-iocn49.png"
                        alt=""
                      />
                    </div>
                    <div slot="reference" class="view-left-card-item-dx-wenhao">
                      <img
                        class="colourless"
                        src="@/assets/answerExam/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="color"
                        src="@/assets/answerExam/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                  <div class="view-left-card-item-dx-here">添加到此处</div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </el-scrollbar>
      </el-card>

      <div class="view-right-card" v-loading="isLoading">
        <el-card class="view-right-top-card">
          <div slot="header" class="view-right-card-title">
            <el-input
              v-model="examName"
              placeholder="请输入问卷标题"
            ></el-input>
            <el-button type="primary" @click.stop="saveAnswerExam"
              >保存问卷</el-button
            >
          </div>
        </el-card>
        <el-scrollbar>
          <div class="view-right-down">
            <draggable
              v-model="moveBeforeQuestionList"
              animation="300"
              group="answer_exam"
              @add="addLeftQuestions"
              handle=".mover"
              @start="onMoveStart"
              @end="onMoveEnd"
            >
              <transition-group
                tag="div"
                :class="{ active: questionsList.length <= 0 }"
              >
                <template>
                  <div
                    v-for="(item, index) in questionsList"
                    :key="index"
                    style="margin-bottom: 20px"
                  >
                    <TEST_XZT
                      v-if="item.type == 'XZT_DXT' || item.type == 'XZT_DDXT'"
                      :textItem="item"
                      :textIndex="index"
                      :textArray="questionsList"
                    ></TEST_XZT>
                    <TEST_WDT
                      v-if="item.type == 'ZGT_WDT'"
                      :textItem="item"
                      :textIndex="index"
                      :textArray="questionsList"
                    ></TEST_WDT>
                    <TEST_HXTKT
                      v-if="item.type == 'ZGT_HXTKT'"
                      :textItem="item"
                      :textIndex="index"
                      :textArray="questionsList"
                    ></TEST_HXTKT>
                    <TEST_YZT_XB_NL
                      v-if="item.type == 'YZT_XB' || item.type == 'YZT_NL'"
                      :textItem="item"
                      :textIndex="index"
                      :textArray="questionsList"
                    ></TEST_YZT_XB_NL>
                    <TEST_YZT_SJH_XM
                      v-if="item.type == 'YZT_SJH' || item.type == 'YZT_XM'"
                      :textItem="item"
                      :textIndex="index"
                      :textArray="questionsList"
                    ></TEST_YZT_SJH_XM>
                  </div>
                </template>
              </transition-group>
            </draggable>
            <el-card
              class="view-right-down-card"
              v-if="questionsList.length == 0"
            >
              <div class="view-right-down-card-area">
                <img src="@/assets/answerExam/question_nodata.png" alt="" />
                <p>点击题型或将题型拖入此区域</p>
              </div>
            </el-card>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import $answer from "@/api/answerExam";
//引入draggable组件
import draggable from "vuedraggable";
//选择题组件
import TEST_XZT from "@/components/answerExam/TEST_XZT";
//问答题组件
import TEST_WDT from "@/components/answerExam/TEST_WDT";
//横向填空题组件
import TEST_HXTKT from "@/components/answerExam/TEST_HXTKT";
//预制题手机号和预制题姓名
import TEST_YZT_SJH_XM from "@/components/answerExam/TEST_YZT_SJH_XM";
//预制题年龄和预制题性别
import TEST_YZT_XB_NL from "@/components/answerExam/TEST_YZT_XB_NL";
export default {
  props: ["changes"],
  components: {
    draggable,
    TEST_XZT,
    TEST_WDT,
    TEST_HXTKT,
    TEST_YZT_SJH_XM,
    TEST_YZT_XB_NL,
  },
  data() {
    return {
      isLoading: false,
      //移动前数组
      moveBeforeQuestionList: [],
      //移动后数组
      questionsList: [],
      leftDrager: {
        group: {
          name: "answer_exam",
          pull: "clone",
          put: false,
        },
      },
      examName: "",
      examId: "",
      //单选题
      addQuestionsListXZT: [],
      //多选题
      addQuestionsListDXT: [],
      //问答题
      addQuestionsListWDT: [],
      //横向填空题
      addQuestionsListHXTKT: [],
      //姓名
      addQuestionsListYZTXM: [],
      //性别
      addQuestionsListYZTXB: [],
      //年龄
      addQuestionsListYZTNL: [],
      //手机号
      addQuestionsListYZTSJH: [],
      addQuestionsList: [],
    };
  },
  methods: {
    addLeftQuestions: function (e) {
      console.log("=======e========", e.oldIndex);
      console.log(
        "=======addQuestionsList=====",
        this.addQuestionsList[e.oldIndex]
      );
      // let copyObj = this.$objCopy.objAllCopy(this.addQuestionsList[e.oldIndex]);
      // this.questionsList.push(copyObj);
    },
    addClick(item) {
      console.log(item);
      let newItem = JSON.parse(JSON.stringify(item))
      // 重置item
      if (this.questionsList.length >= 1) {
        newItem.case_problem = null;
        if (newItem.choose_list) {
          newItem.choose_list.forEach((zitem) => {
            zitem.text = "";
          });
        }
        this.questionsList.push(newItem);
      }else{
        this.questionsList.push(item);
      }
      // this.addMoveEnd()
      // console.log(this.addQuestionsListXZT);
      // this.moveBeforeQuestionList = this.$objCopy.listAllCopy(
      //   this.questionsList
      // );
      // this.questionsList = this.$objCopy.listAllCopy(
      //   this.moveBeforeQuestionList
      // );
    },
    addMoveStart: function (e) {
      console.log(e, "开始移动left数组");
      this.moveBeforeQuestionList = this.$objCopy.listAllCopy(
        this.questionsList
      );
      console.log("=======questionsList=====", this.questionsList);
      console.log("========start===", e);
    },
    addMoveEnd: function (e) {
      console.log(e, "结束移动left数组");
      this.questionsList = this.$objCopy.listAllCopy(
        this.moveBeforeQuestionList
      );
      console.log("=======questionsList=====", this.questionsList);
    },
    onMoveStart: function (e) {
      console.log(e, "开始移动right数组");
      console.log("before.questionsListbefore==", this.questionsList);
      this.moveBeforeQuestionList = this.$objCopy.listAllCopy(
        this.questionsList
      );
      console.log("before.questionsListAfter==", this.questionsList);
      console.log("beforequestionsList==", this.moveBeforeQuestionList);
    },
    onMoveEnd: function (e) {
      console.log(e, "结束移动right数组");
      console.log("beforequestionsList==", this.moveBeforeQuestionList);
      this.questionsList = this.$objCopy.listAllCopy(
        this.moveBeforeQuestionList
      );
      console.log("that.questionsList==", this.questionsList);
    },
    initXZT: function () {
      //选择题
      let questionsXZT = [];
      questionsXZT = this.addQuestionsList.filter((res) => {
        return res.type == "XZT";
      });
      questionsXZT.forEach((result) => {
        let questionsXZTChild = result.children;
        if (questionsXZTChild) {
          questionsXZTChild.forEach((res) => {
            switch (res.type) {
              //单选题
              case "XZT_DXT":
                this.addQuestionsListXZT = [res];
                break;
              //多选题
              case "XZT_DDXT":
                this.addQuestionsListDXT = [res];
                break;
              default:
                return "";
            }
          });
        }
      });
    },
    initZGT: function () {
      //主观题
      let questionsZGT = [];
      questionsZGT = this.addQuestionsList.filter((res) => {
        return res.type == "ZGT";
      });
      questionsZGT.forEach((result) => {
        let questionsZGTChild = result.children;
        if (questionsZGTChild) {
          questionsZGTChild.forEach((res) => {
            switch (res.type) {
              //问答题
              case "ZGT_WDT":
                this.addQuestionsListWDT = [res];
                break;
              //横向填空题
              case "ZGT_HXTKT":
                this.addQuestionsListHXTKT = [res];
                break;
              default:
                return "";
            }
          });
        }
      });
    },
    initYZT: function () {
      //预置题
      let questionsYZT = [];
      questionsYZT = this.addQuestionsList.filter((res) => {
        return res.type == "YZT";
      });
      questionsYZT.forEach((result) => {
        let questionsYZTChild = result.children;
        if (questionsYZTChild) {
          questionsYZTChild.forEach((res) => {
            switch (res.type) {
              //姓名
              case "YZT_XM":
                this.addQuestionsListYZTXM = [res];
                break;
              //性别
              case "YZT_XB":
                this.addQuestionsListYZTXB = [res];
                break;
              //年龄
              case "YZT_NL":
                this.addQuestionsListYZTNL = [res];
                break;
              //手机号码
              case "YZT_SJH":
                this.addQuestionsListYZTSJH = [res];
                break;
              default:
                return "";
            }
          });
        }
      });
    },
    initAnswerStyle: async function () {
      this.isLoading = true;
      let parms = {};
      parms = this.getParms(parms);
      let { data } = await $answer.getAnswerStyle(parms);
      if (data.Status === 200) {
        this.addQuestionsList = data.Data;
        this.initXZT();
        this.initZGT();
        this.initYZT();
      } else {
        this.$message.error("获取题目样式失败！");
      }
      this.isLoading = false;
    },
    saveAnswerExam: function () {
      if (this.questionsList.length == 0) {
        this.$message.warning("请先选择题目！");
        return;
      }
      if (!this.examName) {
        this.$message.warning("问卷题目不能为空！");
        return;
      }
      //重置题目顺序
      this.questionsList.forEach((res, index) => {
        res.sort = index + 1;
        if (!res.case_problem) {
          res.case_problem = res.placeholder;
        }
      });
      this.isLoading = true;
      let parms = {};
      parms = this.getParms(parms);
      parms.questionsList = this.questionsList;
      parms.examName = this.examName;
      parms.examId = this.examId;
      console.log("questionsList=========", this.questionsList);
      $answer
        .saveAnswerExam(parms)
        .then((res) => {
          let data = res.data;
          if (data.Status == 200) {
            this.$message.success("保存问卷成功！");
            console.log("res========", res);
            this.backBtn();
          } else {
            this.$message.error(data.Msg);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.$message.error("保存问卷失败！");
          this.isLoading = false;
        });
    },
    // 封装方法
    getParms: function (paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    //返回
    backBtn: function () {
      this.$parent.changes(0);
    },
    getAnswerExamPaperTest: async function () {
      const parms = {};
      this.getParms(parms);
      parms.examId = this.examId;
      const { data } = await $answer.getAnswerExamPaperTest(parms);
      if (data.Status === 200) {
        this.questionsList = data.Data;
        this.examName = this.$parent.$children[0].rowExamName;
      } else {
        this.$message.error("获取调查问卷题目失败！");
      }
    },
  },
  computed: {},
  //被keep-alive组件包裹时使用
  activated() {
    console.log("执行了makeAnswerExam");
    this.examId = this.$parent.$children[0].rowExamId;
    this.initAnswerStyle();
    this.getAnswerExamPaperTest();
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-scrollbar__wrap {
  overflow: scroll-y;
  overflow-x: hidden;
  height: 680px;
}
::v-deep .el-card__body {
  padding: 0px 0px 0px 0px;
}
::v-deep .el-card__header {
  height: 61px !important;
}
.content {
  height: 100%;
  width: 100%;
  padding: 0px 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  .back {
    border-bottom: 1px solid #f8f8f8;
    background-color: #fff;
    width: 140px;
    padding: 10px;
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-top: 2px solid #999999;
      border-left: 2px solid #999999;
      transform: scaleY(0.6) rotate(-45deg);
    }
    span {
      cursor: pointer;
      width: 47px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
}
.view-body {
  display: flex;
  height: 100%;
  width: 100%;
  /*padding: 30px 0px 30px 0px;*/
  .view-left-card {
    height: 100%;
    width: 300px;
    .view-left-card-title {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 18px;
        font-weight: bold;
        color: #4c4c4c;
      }
    }
    .view-left-card-item {
      display: flex;
      flex-flow: column nowrap;
      margin-bottom: 20px;
      padding: 16px 0px 0px 16px;
      .view-left-card-item-span {
        font-size: 16px;
        font-weight: 400;
        color: #555a64;
        margin-bottom: 12px;
      }
      .view-left-card-item-dx {
        display: flex;
        margin-bottom: 9px;
        width: 260px;
        height: 40px;
        background: #fcfcfc;
        border: 1px solid #e6e6e6;
        cursor: pointer;
        border-radius: 3px;
        .view-left-card-item-dx-wenhao {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            margin-right: 10px;
            width: 16px;
            height: 16px;
          }
        }
        .view-left-card-item-dx-content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          margin-left: 90px;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #7a8089;
          }
          img {
            margin-right: 10px;
            width: 16px;
            height: 16px;
          }
        }
        .view-left-card-item-dx-here {
          display: none;
        }
        .color {
          display: none;
        }
        &:hover {
          background: rgba(30, 128, 255, 0.08);
          border-color: #1e80ff;
          span {
            color: #1e80ff;
          }
          .color {
            display: inline-block;
          }
          .colourless {
            display: none;
          }
        }
      }
    }
  }
  .view-right-card {
    width: 790px;
    display: flex;
    flex-flow: column nowrap;
    margin-left: 20px;
    .view-right-top-card {
      width: 790px;
      .view-right-card-title {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        ::v-deep .el-input {
          display: flex;
          justify-content: center;
          width: 100%;
          .el-input__inner {
            width: 60%;
            text-align: center;
            border: 0px solid #dcdfe6;
            font-size: 20px;
            &:hover {
              border: 1px dashed #dcdfe6;
            }
            &:focus-within {
              background-color: #f4f4f4;
            }
          }
          .el-input__inner::placeholder {
            color: #1e80ff;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
    }
    .active {
      margin-top: 20px;
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 642px;
    }
    .view-right-down-card {
      margin-top: 20px;
      width: 790px;
      height: 642px;
      flex-flow: column nowrap;
      position: relative;
      display: flex;
      .view-right-down-card-area {
        position: absolute;
        top: 230px;
        text-align: center;
        left: 300px;
        img {
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: #7a8089;
        }
      }
    }
  }
  /*选中样式*/
  .chosenClass {
    width: 790px;
    height: 40px;
    background-color: #1e80ff80;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    img {
      display: none;
    }
  }
}
</style>
